
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Checkbox, FormControlLabel, Button } from '@mui/material';
import { addClinic, ClinicDetailsById, ClinicInfoFormData, DepartmentResponseItem, getDepartmentList } from './clinicHelper';
import { useAlert } from '../alertProvider';
import { useLoader } from '../loaderProvider/loader';
import { useParams } from 'react-router-dom';


export interface DepartmentProps {
    onCancel: () => void;
    formSubmitedvalues?: ClinicInfoFormData | null;
}




const DepartmentStoreSelect: React.FC<DepartmentProps> = ({ onCancel, formSubmitedvalues }) => {
  const [departmentList, setDepartmentList] = useState<DepartmentResponseItem[]>([]);
  const [selectedDepartments, setSelectedDepartments] = useState<number[]>([]);
  const { id } = useParams<{ id: string }>();
  const { addAlert } = useAlert();
  const { showLoader, hideLoader } = useLoader();
  
  //   const [selectedStores, setSelectedStores] = useState<string[]>(['Store Name 1', 'Store Name 3', 'Store Name 4', 'Store Name 5']);

  useEffect(() => {
    getDepartmentList().then((data) => {
      console.log('Department data:', data);
      setDepartmentList(data);
    });
  }, []);

  //Edit mode
  useEffect(() => {
    if (id) {
      ClinicDetailsById(id)
        .then((data: ClinicInfoFormData) => {
          // Match by name instead of id
          const selectedNames = data.departments?.map(dep => dep.name) || [];
          setSelectedDepartments(
            departmentList
              .filter(dept => selectedNames.includes(dept.name))
              .map(dept => dept.id)
          );
        });
    }
  }, [id, departmentList]);

  const handleDepartmentChange = (deptId: number) => {
    setSelectedDepartments((prev) =>
      prev.includes(deptId) ? prev.filter((id) => id !== deptId) : [...prev, deptId]
    );
  };

  const handleSubmit = (payload: ClinicInfoFormData) => {
    showLoader();
    addClinic(payload)
      .then((response) => {
        console.log('response', response);
        hideLoader();
        addAlert('Clinic created successfully', 'success');
        onCancel();
        
      })
      .catch((error) => {
        hideLoader();
        if (error?.response?.data?.errors && Array.isArray(error.response.data.errors)) {
          const errorMessage = error.response.data.errors.map((err: { detail: string }) => err.detail).join(', ');
          addAlert(errorMessage, 'error');
        } else {
          console.error('Error creating clinic:', error);
          addAlert('Error creating clinic', 'error');
        }
      });
  };

  //   const handleStoreChange = (store: string) => {
  //     setSelectedStores((prev) =>
  //       prev.includes(store) ? prev.filter((s) => s !== store) : [...prev, store]
  //     );
  //   };


  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                Select Department
      </Typography>
      <Grid container spacing={2} mb={3}>
        {departmentList.map((dept) => (
          <Grid item key={dept.id}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedDepartments.includes(dept.id)}
                  onChange={() => handleDepartmentChange(dept.id)}
                  sx={{
                    borderRadius: '18px',
                    '&.Mui-checked': {
                      color: '#43B97F',
                    },
                  }}
                />
              }
              label={
                <Typography sx={{ fontWeight: selectedDepartments.includes(dept.id) ? 700 : 500 }}>
                  {dept.name}
                </Typography>
              }
              sx={{
                m: 0,
                px: 2,
                py: 1,
                borderRadius: 2,
                background: selectedDepartments.includes(dept.id) ? '#FFFFFF' : '#FAFAFA',
                boxShadow: selectedDepartments.includes(dept.id) ? 1 : 0,
                minWidth: 180,
              }}
            />
          </Grid>
        ))}
      </Grid>
      {/* // store */}
      {/* <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>Select Store</Typography>
      <Grid container spacing={2} mb={3}>
        {STORES.map((store) => (
          <Grid item key={store}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedStores.includes(store)}
                  onChange={() => handleStoreChange(store)}
                  sx={{
                    '&.Mui-checked': {
                      color: '#43B97F',
                    },
                  }}
                />
              }
              label={<Typography sx={{ fontWeight: selectedStores.includes(store) ? 700 : 500 }}>{store}</Typography>}
              sx={{
                m: 0,
                px: 2,
                py: 1,
                borderRadius: 2,
                background: selectedStores.includes(store) ? '#FFFFFF' : '#FAFAFA',
                boxShadow: selectedStores.includes(store) ? 1 : 0,
                // border: selectedStores.includes(store) ? '1px solid #43B97F' : '1px solid #E0E0E0',
                minWidth: 180,
              }}
            />
          </Grid>
        ))}
      </Grid> */}
      <Box display="flex" justifyContent="flex-end" gap={2} mt={4}>
        <Button variant="outlined" onClick={onCancel}>Cancel</Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: '#3e3e3e', color: '#fff', boxShadow: 'none', '&:hover': { backgroundColor: '#222' } }}
          onClick={() => {
            if (formSubmitedvalues) {
              const payload = {
                ...formSubmitedvalues,
                department_master_ids: selectedDepartments,
              };
              handleSubmit(payload);
            } else {
              console.warn('No formSubmitedvalues provided');
            }
          }}
        >
          Save
        </Button>

      </Box>
    </Box>
  );
};

export default DepartmentStoreSelect;
